/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC } from "react";

import { IScheduleCardProps } from "types/components/common/scheduleCard";

import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import styles from "./index.module.scss";


const convertTo24HourFormat = (time12h: string): string => {
  const [time, modifier] = time12h.split(' ');

  // eslint-disable-next-line
  let [hours, minutes] = time.split(':');

  if (hours === '12') {
    hours = '00';
  }

  if (modifier === 'PM') {
    hours = (parseInt(hours, 10) + 12).toString();
  }

  return `${hours.padStart(2, '0')}:${minutes}`;
};


const ScheduleCard: FC<IScheduleCardProps> = ({
  className,
  item,
}) => {

  const { dir, language } = useAppSelector(getSettings);

  return (
    <div className={`flex flex-col w-full h-fit`} dir={dir}>
      {item.events.map((eventItem, index) => (
        <div className={`${styles["schedule-card-item"]} my-2`} style={{
          background: eventItem.color,
        }} key={index} dir={dir}>
          <p className=" font-light text-sm">{convertTo24HourFormat(eventItem.start)} - {convertTo24HourFormat(eventItem.end)}</p>
          <h3 className={styles["schedule-card-item__title"] }>{eventItem.title[language]}</h3>
          <p className={`${styles["schedule-card-item__type"]} font-light`}>{eventItem.description[language]}</p>
        </div>
      ))}
    </div>
  );
};
export default ScheduleCard;
